import "regenerator-runtime/runtime";
import React from "react";
import PublicationTypes from "./publication_types";
import YearsGroup from "./publications/years_group";

import useSWR from "swr";
import "./styles.scss";

const PUBDB_staffmember_URL =
  "https://publikationen.dipf.de/litdipfjson/publikationen.php?hisid=";

const PUBDB_projekt_URL =
  "https://publikationen.dipf.de/litdipfjson/publikationen.php?projektnummer=";

const PUBDB_projekts_URL =
  "https://publikationen.dipf.de/litdipfjson/publikationen.php?";

function addToPublications(pub_obj, type_short, year, publication, hisid) {
  "use strict";
  /***
   * Adds publication to correct type and year
   */
  // Drop publication if "show pers page" is false and its a stuffmember with an his id
  if (publication["show_pers_page"] === "N" && hisid) {
    return pub_obj;
  }
  // Create new type
  if (pub_obj[type_short] === undefined) {
    pub_obj[type_short] = {};
  }
  if (pub_obj[type_short][year] === undefined) {
    pub_obj[type_short][year] = { publications: [publication] };
  } else {
    // Add to existing type
    pub_obj[type_short][year]["publications"].push(publication);
  }
  return pub_obj;
}

function sortData(data, lang, hisid) {
  "use strict";
  /***
   * Sorts the publication into types
   */
  let sorted_publications = {};
  Object.keys(data).map((key) => {
    let publication = data[key];
    let Beitragsart = publication.Beitragsart || "";
    let type_short, type_name_de, type_name_en, skip_publication;
    switch (true) {
      case publication.type === "1. Monographien (Autorenschaft) (M)" ||
        publication.type === "Monographien (Autorenschaft) (M)":
        type_short = "1";
        type_name_de = "Monographien (Autorenschaft)";
        type_name_en = "Monographs (Authorship)";
        break;
      case publication.type === "2. Herausgeberschaft (M)" ||
        publication.type ===
          "Sammelbände; Werkeditionen (Herausgeberschaft) (M)" ||
        publication.type ===
          "Sammelbände; Werkeditionen (Herausgeberschaft) (G)":
        type_short = "2";
        type_name_de = "Sammelbände (Herausgeberschaft)";
        type_name_en = "Collected Editions (Editorships)";
        break;
      case publication.type ===
        "3a. Beiträge in begutachteten Zeitschriften (Z)" ||
        (publication.type === "Zeitschriftenbeiträge (Z)" &&
          publication.referiert === "Full Text Peer Review" &&
          Beitragsart !== "Zeitschriften-Kurzbeiträge"):
        type_short = "3a";
        type_name_de = "Zeitschriftenbeiträge mit Peer Review";
        type_name_en = "Journal Articles (Peer-Reviewed Journals)";
        break;
      //III.2.5. Zuordnung in die Kategorie „Weitere Zeitschriftenbeiträge“ wenn Wert im Feld „referiert“ ist „nicht begutachtet“
      case publication.type === "Zeitschriftenbeiträge (Z)" &&
        publication.referiert === "nicht begutachtet" &&
        Beitragsart !== "Zeitschriften-Kurzbeiträge":
        type_short = "3b";
        type_name_de = "Weitere Zeitschriftenbeiträge";
        type_name_en = "Journal Articles";
        break;
      //III.2.6. Zuordnung in die Kategorie „Zeitschriften-Kurzbeiträge“ wenn Wert im Feld „Beitragsart“ ist „Zeitschriften-Kurzbeiträge“
      case publication.Beitragsart === "Zeitschriften-Kurzbeiträge":
        type_short = "3c";
        type_name_de = "Zeitschriften-Kurzbeiträge";
        type_name_en = "Brief Journal Contributions";
        break;
      //III.2.7. Zuordnung in die Kategorie „Sammelband- und Proceedingsbeiträge mit Full Text Peer Review“ wenn Wert im Feld „referiert“ ist „Full Text Peer Review“
      case publication.type === "Beiträge in Sammelbänden (S)" &&
        publication.referiert === "Full Text Peer Review":
        type_short = "4";
        type_name_de =
          "Sammelband- und Proceedingsbeiträge mit Full Text Peer Review";
        type_name_en =
          "Book Chapters and Proceedings Papers (Full Text Peer Review)";
        break;
      //III.2.8.Zuordnung in die Kategorie „Sammelband- und Proceedingsbeiträge mit Abstract Peer Review“ wenn Wert im Feld „referiert“ ist „Abstract Peer Review“
      case publication.type === "Beiträge in Sammelbänden (S)" &&
        publication.referiert === "Abstract Peer Review":
        type_short = "4a";
        type_name_de =
          "Sammelband- und Proceedingsbeiträge mit Abstract Peer Review";
        type_name_en =
          "Book Chapters and Proceedings Papers (Abstract Peer Review)";
        break;
      //III.2.9. Zuordnung in die Kategorie „Weitere Sammelband- und Proceedingsbeiträge“ wenn Wert im Feld „referiert“ ist „nicht begutachtet“
      case publication.type === "Beiträge in Sammelbänden (S)" &&
        publication.referiert === "nicht begutachtet":
        type_short = "4b";
        type_name_de = "Weitere Sammelband- und Proceedingsbeiträge";
        type_name_en = "Book Chapters and Proceedings Papers";
        break;
      case publication.type.includes(
        "Arbeitspapiere; dokumentarische und Diskussionsbeiträge",
      ):
        type_short = "6";
        type_name_de =
          "Arbeitspapiere, dokumentarische und Diskussionsbeiträge";
        type_name_en = "Working Papers, Documentations, Discussion Papers";
        break;
      case publication.type === "Forschungsdaten; Instrumente (G)":
        type_short = "7";
        type_name_de = "Forschungsdaten und diagnostische Instrumente";
        type_name_en = "Research Data, Diagnostic Instruments";
        break;
      case publication.type === "7. Blogbeiträge; Pod-/Vidcasts" ||
        publication.type === "Blogbeiträge; Pod-/Vidcasts":
        type_short = "8";
        type_name_de = "Blogbeiträge; Pod-/Vidcasts";
        type_name_en = "Blog posts; Pod-/Vidcasts";
        break;
      default:
        skip_publication = true;
    }
    // Translate
    if (lang === "de") {
      publication.type = type_name_de;
    } else {
      publication.type = type_name_en;
    }
    if (!skip_publication) {
      sorted_publications = addToPublications(
        sorted_publications,
        type_short,
        publication.year,
        publication,
        hisid,
      );
    }
  });
  return sorted_publications;
}

const PublicationApp = ({ hisid, projekt_ids }) => {
  var lang = document.documentElement.lang || "de";

  let url = PUBDB_staffmember_URL + hisid;
  if (projekt_ids) {
    let projekt_list = JSON.parse(projekt_ids);
    if (projekt_list.length === 1) {
      url = PUBDB_projekt_URL + projekt_list[0];
    }
    if (projekt_list.length > 1) {
      var url_part;
      for (let item in projekt_list) {
        let query_part = `projektnummer[]=${projekt_list[item]}`;
        url_part += "&" + query_part;
      }
      console.log(url_part);
      if (url_part) {
        url = PUBDB_projekts_URL + url_part;
      }
    }
  }

  const { data, error } = useSWR("/publications", async () => {
    const response = await fetch(url);
    let pub_data = await response.json();
    return sortData(pub_data["trefferliste"], lang, hisid);
  });

  if (!data) {
    return lang === "de" ? (
      <div>Lade Publikationen...</div>
    ) : (
      <div>Loading...</div>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="publications">
      <div id="types">
        {Object.keys(data)
          .sort()
          .map((type) => (
            <PublicationTypes key={type} type_short={type} type={data[type]} />
          ))}
      </div>
      <div id="publications-list">
        {Object.keys(data)
          .sort()
          .map((key) => {
            let first_year = Object.keys(data[key])[0];
            return (
              <div key={key}>
                <h4 id={`pub${key}`}>
                  {data[key][first_year]["publications"][0]["type"]}
                </h4>
                <YearsGroup years={data[key]} />
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default PublicationApp;
